'use client';

import React from 'react';
import {
  ThemeProvider as ThemeProviderRaw,
  createGlobalStyle,
} from 'styled-components';

// @types/styled-components@5 ships pre-React-18 class typings that fail JSX
// element-type checks under @types/react@18 (missing `refs` on Component).
// Re-typing the few class components we use as plain FCs is the standard
// workaround until we move to styled-components 6.
const ThemeProvider = ThemeProviderRaw as unknown as React.FC<{
  theme: object;
  children?: React.ReactNode;
}>;
import { lightTheme, darkTheme } from '../tokens/theme';
import { DensityProvider } from './DensityContext';
import { LabelsProvider, type OpsLabels } from './LabelsProvider';
import type { Density } from '../tokens/density';

const BaselineStylesRaw = createGlobalStyle`
  body {
    font-family: ${({ theme }: any) => theme.fontFamily.ui};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
`;
const BaselineStyles = BaselineStylesRaw as unknown as React.FC;

export interface OpsThemeProviderProps {
  mode?: 'light' | 'dark';
  density?: Density;
  labels?: OpsLabels;
  children: React.ReactNode;
}

export function OpsThemeProvider({
  mode = 'light',
  density = 'comfortable',
  labels,
  children,
}: OpsThemeProviderProps) {
  const theme = mode === 'dark' ? darkTheme : lightTheme;
  return (
    <ThemeProvider theme={theme}>
      <BaselineStyles />
      <DensityProvider density={density}>
        <LabelsProvider labels={labels}>{children}</LabelsProvider>
      </DensityProvider>
    </ThemeProvider>
  );
}
